import { styled } from '../../Utilities';
import { ButtonGridBase } from './ButtonGrid.base';
import { getStyles } from './ButtonGrid.styles';
export var ButtonGrid = styled(ButtonGridBase, getStyles);
ButtonGrid.displayName = 'ButtonGrid';
//# sourceMappingURL=ButtonGrid.js.map